<ng-container *ngIf="banner$ | async as bannerState">
  <ng-container *ngIf="bannerState.isLoading">
    <spinner></spinner>
  </ng-container>

  <ng-container *ngIf="!bannerState.isLoading">
    <div class="card card-banner">
      <div class="card-body p-0">
        <div class="row tile-content banner-row">
          <div class="col-12">
            <ng-container *ngIf="bannerState.size !== 'small'; else mobile">
              <div
                class="bg-image bg-size"
                [style.backgroundImage]="'url(' + bannerState.banner[0].medium_image + ')'"
                (click)="openBanner(bannerState.banner[0].url)"
              ></div>
            </ng-container>

            <ng-template #mobile>
              <div
                class="bg-image bg-size"
                [style.backgroundImage]="'url(' + bannerState.banner[0].small_image + ')'"
                (click)="openBanner(bannerState.banner[0].url)"
              ></div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
